// extracted by mini-css-extract-plugin
module.exports = {"docLink":"_3QHlkweOdYhFnaIOBR0rRa","addRowButton":"POlT9HEezJKKLJ5DeVQmM","deleteRowButton":"_32Rtb0lEI_EiFejqtCIi0q","tableContainer":"_2yOTok24WPjoYvue-vrpkn"};